<template>
  <div>
    <AdsBanner
      :title="formData.title"
      :description="formData.description"
      :thumbnail-url="formData.coverPreview"
      :button-link="formData.button_link"
      :button-name="formData.button_name"
      :type="formData.banner_type"
    />
  </div>
</template>

<script>
import AdsBanner from '../../shared/components/banners/AdsBanner'

export default {
  name: 'App',
  components: { AdsBanner },
  data() {
    return {
      formData: {
        title: '',
        description: '',
        button_name: '',
        button_link: '',
        banner_type: 'vertical',
        coverPreview: window.NO_IMAGE_FALLBACK,
      },
    }
  },
  mounted() {
    const form =
      document.getElementById('edit_ads_banner') ||
      document.getElementById('new_ads_banner')

    if (!form) return

    const inputs = form.querySelectorAll('[name^="ads_banner["]')
    inputs.forEach((input) => {
      const match = input.name.match(/^ads_banner\[(.+)\]$/)
      if (!match) return

      const key = match[1]

      if (!this.formData.hasOwnProperty(key)) return

      if (input.type === 'radio') {
        if (input.checked) this.formData[key] = input.value

        input.addEventListener('change', (e) => {
          if (e.target.checked) this.formData[key] = e.target.value
        })
      } else {
        this.formData[key] = input.value

        input.addEventListener('input', (e) => {
          this.formData[key] = e.target.value
        })
      }
    })

    Object.keys(this.formData).forEach((key) => {
      this.$watch(`formData.${key}`, (newVal) => {
        const input = form.querySelector(`[name="ads_banner[${key}]"]`)
        if (input && input.value !== newVal) input.value = newVal
      })
    })

    const fileInput = document.querySelector('input[name="ads_banner[cover]"]')
    if (fileInput) {
      const previewImg = document.querySelector('#cover-preview img')
      if (
        previewImg &&
        previewImg.src &&
        previewImg.src.startsWith('data:') === false
      ) {
        this.formData.coverPreview = previewImg.src
      }

      fileInput.addEventListener('change', (e) => {
        const file = e.target.files[0]
        if (file) {
          const reader = new FileReader()
          reader.onload = (e) => {
            this.formData.coverPreview = e.target.result

            const img = document.querySelector('#cover-preview img')
            if (img) img.src = e.target.result
          }
          reader.readAsDataURL(file)
        }
      })
    }
  },
}
</script>

<style scoped lang="scss"></style>
